import { LandingFaq } from './landing/LandingFaq.js'
import { LandingFooterCta } from './landing/LandingFooterCta.js'
import { LandingHeader } from './landing/LandingHeader.js'
import { LandingHero } from './landing/LandingHero.js'
import { LandingPain } from './landing/LandingPain.js'
import { LandingPillars } from './landing/LandingPillars.js'
import { LandingSteps } from './landing/LandingSteps.js'
import { LandingTrial } from './landing/LandingTrial.js'
import { useTryFree } from './landing/use-try-free.js'

/**
 * 公開トップ（マーケLP）。
 *
 * - 動画販売業者向けの訴求（止まらない共有 / 爆速アップロード）
 * - 「無料で試す」CTA → FingerprintJS → /hook/initialize → 作業画面
 * - migrated_fingerprints ヒット時はログイン誘導
 */
export function LandingPage() {
  const { loading, error, migratedNotice, onTryFree } = useTryFree()

  return (
    <div className="min-h-screen bg-background">
      <LandingHeader />
      <main>
        <LandingHero
          loading={loading}
          error={error}
          migratedNotice={migratedNotice}
          onTryFree={onTryFree}
        />
        <LandingPain />
        <LandingPillars />
        <LandingSteps />
        <LandingTrial />
        <LandingFaq />
        <LandingFooterCta loading={loading} onTryFree={onTryFree} />
      </main>
    </div>
  )
}
